import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { InstanceUserService } from 'src/app/services/instance-user.service';
import { AuthService } from 'src/app/services/auth.service';
import { TallyReleaseService } from 'src/app/services/tally-release.service';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterPipe } from '../customPipe/filter.pipe';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LogoutComponent } from '../modals/logout/logout.component';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  providers: [FilterPipe]
})
export class UserDetailsComponent implements OnInit {
  subCode: string = ''
  searchField: any = {}
  instanceUser: any = []
  tallyRelease: any = []
  isTally: boolean = false
  bsModalRef!: BsModalRef;
  instanceForm = new FormGroup({
    tallyVersion: new FormControl(''),
    searchText: new FormControl('')
  })

  constructor(
    private modalService: BsModalService,
    private instanceUserService: InstanceUserService,
    private tallyReleaseService: TallyReleaseService,
    private activateRoute: ActivatedRoute,
    private location: Location,
    private toasts: ToastrService,
    public authService: AuthService

  ) { }

  ngOnInit(): void {
    this.location.subscribe(() => {
      const searchQuery = this.searchField;
      const url = `${window.location.pathname}?search=${searchQuery}`;
      window.open(url, '_self')
    });
    this.activateRoute.queryParams.subscribe(data => {
      this.subCode = data['subCode']
      this.searchField = data['search']
    })
    this.tallyVersionList()
    if (this.subCode && this.searchField) {
      this.instanceUserList()
    }
  }

  get searchText() {
    return this.instanceForm.controls.searchText.value || '';
  }

  instanceUserList() {
    this.instanceUserService.instanceUserList(this.searchField).subscribe((res: any) => {
      if (res.success) {
        this.instanceUser = res.instanceUsers
        this.isTally = res.instanceUsers[0]?.plan?.name?.includes('tally')
      }
    }, (error: any) => {
      this.instanceUser = []
      this.toasts.error(error.error.message);
    })
  }

  tallyVersionList() {
    this.tallyReleaseService.tallyReleaseList().subscribe((res: any) => {
      if (res.success) {
        this.tallyRelease = res.tallyVersions
      }
    })
  }

  forceLogOff(instanceUserId: string) {
    this.instanceUserService.forceLogOff(instanceUserId).subscribe((res: any) => {
      if (res.success) {
        this.toasts.success(res.message)
      }
    }, (error: any) => {
      this.toasts.error(error.error.message);
    })
  }

  releaseChangeModal(tallyId: string) {
    this.bsModalRef = this.modalService.show(LogoutComponent, {
      class: 'modal-md',
      backdrop: 'static',
      initialState: {
        tallyId: tallyId,
        subscriptionId: this.instanceUser[0]?._id
      }
    });
    this.bsModalRef.content.event.subscribe((res: any) => {
      if (res === 'ok') {
        this.instanceUserList();
      }
    });
  }


  get userType() {
    return this.authService.userType()
  }
}
